import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Popover from '@mui/material/Popover';
import TextField from '@mui/material/TextField';
import Avatar from '@mui/material/Avatar';
import { styled, useTheme } from '@mui/material/styles';
// import axios from 'axios';
import axios from '../../hooks/fetchWithAuth';
import "../../index.css";
import config from '../../config';
import getCookie from '../../hooks/getCookie';
import { getAvatarUrl } from '../../utils/getAvatarUrl';

const DetailBox = styled('div')(({ theme }) => ({
  backgroundColor: '#313940',
  boxShadow: theme.shadows[5],
  padding: theme.spacing(3),
  color: 'white',
  maxWidth: 300,
  minWidth: 280,
  overflowY: 'auto',
}));

const Members = ({ anchorEl, onClose, selectedCard, addUserToCardState, boardId, fetchLogs }) => {
  const [members, setMembers] = useState([]);
  const [filteredMembers, setFilteredMembers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [boardMembers, setBoardMembers] = useState([]);

  // ip do backend
  const backendIp = config.backend_ip;
  const nameComplete = getCookie("nome_completo");
  const username = getCookie("username");
  const sessionId = getCookie("session_id");

  useEffect(() => {
    fetchMembers();
    fetchBoardMembers();
  }, []);

  const fetchMembers = async () => {
    try {
      const response = await axios.get(`${backendIp}/api/board/ti/list_users`);
      setMembers(response.data);
      setFilteredMembers(response.data);
    } catch (error) {
      return null;
    }
  };

  const fetchBoardMembers = async () => {
    try {
      const response = await axios.put(`${backendIp}/api/board/ti/list_users_in_board`, {
        'board_id': boardId,
        'session_id': sessionId,
        'user': username

      })
      setBoardMembers(response.data);
    } catch (error) {
      return null;
    }
  };

  const addMemberToCard = async (memberName) => {
    try {
      const response = await axios.put(`${backendIp}/api/board/ti/add_user_in_card`, {
        user_in_card: memberName,
        user_card_id: selectedCard.id,
        name_complete: nameComplete,
        user: username,
        session_id: sessionId
      });
      fetchLogs(selectedCard.id);
      addUserToCardState(memberName, selectedCard.id);

    } catch (error) {
      return null;
    }
  };

  const handleClose = () => {
    onClose();
  };

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    setFilteredMembers(members.filter(member =>
      member.nome_completo.toLowerCase().includes(value.toLowerCase())
    ));
  };



  const open = Boolean(anchorEl);

  return (
    <Box sx={{ width: '100%', position: 'relative' }}>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <DetailBox>
          <p className='paragraph-members'>Membros</p>
          <TextField
            placeholder='Pesquisar membros'
            variant="outlined"
            value={searchTerm}
            onChange={handleSearchChange}
            size="small"
            sx={{
              width: '280px',
              marginRight: '10px',
              borderRadius: '6px',
              '& .MuiOutlinedInput-root': {
                backgroundColor: 'var(--textfield-bg-color, #fff)',
                color: 'var(--textfield-text-color, #000)',
                '& fieldset': {
                  borderColor: 'var(--textfield-border-color, #ccc)',
                },
                '&:hover fieldset': {
                  borderColor: 'var(--textfield-hover-border-color, #aaa)',
                },
                '&.Mui-focused fieldset': {
                  borderColor: 'var(--textfield-focus-border-color)',
                },
              },
              '& .MuiInputLabel-root': {
                color: 'var(--textfield-label-color, #000)',
              },
              '& .Mui-focused .MuiInputLabel-root': {
                color: 'var(--textfield-label-focus-color)',
              },
              '& .MuiInputBase-input': {
                color: 'var(--textfield-text-color, #000)',
              },
            }}
          />
          <p className='paragraph-members2'>Membros do Quadro</p>
          <ul style={{ padding: '0px' }}>
            {filteredMembers.map((member, index) => {
              const isMemberInBoard = boardMembers.some((boardMember) => parseInt(boardMember.user_id) == parseInt(member.userId));
              return isMemberInBoard && (
                <li className='member-select' key={index} onClick={() => addMemberToCard(member.Nome)} >
                  <Avatar src={getAvatarUrl(member.Nome)} style={{ width: '30px', height: '30px', marginTop: '5px' }} />
                  <span className='span-nome_completo' style={{ marginLeft: '10px', fontSize: '14px' }}>{member.nome_completo}</span>
                </li>
              );
            })}
          </ul>
        </DetailBox>
      </Popover>
    </Box>
  );
};

export default Members;